<div class="image-container">

  <div class="navigation-bar2">
    <div class="breadcrumb">
      <a href="/home">{{ translationService.getTranslation('Inicio') }}</a> /
      <a href="/story">{{ pageInfo.title }}</a> /
      <span>{{ translationService.getTranslation('Capitulo') }} {{ pageInfo.caption }}</span>
    </div>
  </div>



  <!-- Información inicial -->
  <div class="initial-info">
    <h1 class="title-chapter">
      {{ pageInfo.title }} - {{ translationService.getTranslation('Capitulo') }} {{ pageInfo.caption }}
    </h1>
    <p class="views">{{ pageInfo.views }} {{ translationService.getTranslation('Vistas') }}</p>
    
  </div>






  <!-- Barra de navegación -->
  <div class="navigation-bar">

    <div class="navigation-controls">
      <select [(ngModel)]="selectedChapter" (change)="onChapterChange($event)">
        <option *ngFor="let chapter of chapters" [value]="chapter">{{ chapter }}</option>
      </select>

    </div>
    <div class="favorite-controls">
      <button (click)="toggleFavorite()" class="favorite-button">
        <i [class]="isFavorite ? 'fas fa-star' : 'far fa-star'"></i>
      </button>
    </div>
  </div>

  <!-- Botones de navegación -->
  <div class="button-container">
    <button (click)="previous()" class="nav-button">&#10094; {{ translationService.getTranslation('Anterior') }}</button>
    <button (click)="next()" class="nav-button">{{ translationService.getTranslation('Siguiente') }} &#10095;</button>
  </div>

  <!-- Imágenes -->
  <div *ngFor="let image of images" class="image-item">
    <img [src]="image" alt="Image" />
  </div>




    <!-- Información inicial -->
    <div class="initial-info">
      <p class="views">{{ pageInfo.views }} {{ translationService.getTranslation('Vistas') }}</p>
      
      <!-- Nueva sección para el autor y el botón de suscribirse -->
      <div class="author-subscribe">
        <div class="author-info">
          <div class="author-avatar">{{ pageInfo.authorInitial }}</div>
          <div>
            <span class="author-name">{{ pageInfo.author }}</span>
            <p class="subscriber-count">{{ pageInfo.subscribers }} {{ translationService.getTranslation('Suscriptores') }}</p>
          </div>
        </div>
        <button class="subscribe-button">{{ translationService.getTranslation('Suscribirse') }}</button>
      </div>
    </div>

    <!-- Barra de navegación -->
    <div class="navigation-bar">
     
      <div class="navigation-controls">
        <select [(ngModel)]="selectedChapter" (change)="onChapterChange($event)">
          <option *ngFor="let chapter of chapters" [value]="chapter">{{ chapter }}</option>
        </select>
  
      </div>
      <div class="favorite-controls">
        <button (click)="toggleFavorite()" class="favorite-button">
          <i [class]="isFavorite ? 'fas fa-star' : 'far fa-star'"></i>
        </button>
      </div>
    </div>
  
    <!-- Botones de navegación -->
    <div class="button-container">
      <button (click)="previous()" class="nav-button">&#10094; {{ translationService.getTranslation('Anterior') }}</button>
      <button (click)="next()" class="nav-button">{{ translationService.getTranslation('Siguiente') }} &#10095;</button>
    </div>

    <div id="disqus_thread"></div>
    <script>
        var disqus_config = function () {
            this.page.url = window.location.href;  // URL canónica de la página
            this.page.identifier = '{{ pageInfo.title }}-{{ pageInfo.caption }}'; // Identificador único para la página
        };

        (function() { // DON'T EDIT BELOW THIS LINE
            var d = document, s = d.createElement('script');
            s.src = 'https://minuscreators.disqus.com/embed.js';
            s.setAttribute('data-timestamp', +new Date());
            (d.head || d.body).appendChild(s);
        })();
    </script>
    <noscript>Please enable JavaScript to view the <a href="https://disqus.com/?ref_noscript">comments powered by Disqus.</a></noscript>
</div>